import { combineReducers } from 'redux';
import { bazaarVoiceRatingsReducer } from '@gcc/pip-components/dist/BazaarVoice';
import storage from 'redux-persist/lib/storage';
import { persistReducer, createMigrate } from 'redux-persist';
import configurator from './configurator';
import productReducer from './products';
import draftingToolReducer from './draftingTool';
import countertopsReducer from './countertops';
import zipcodeReducer from './zipcode';
import storeReducer from './store';
import designReducer from './design';
import persistedShapeInfo from './persistedShape';
import config from './config';
import plaConfigurationReducer from './plaConfiguration';
import sinkQuantityWarningReducer from './sinkQuantityWarning';
import imageAssistReducer from './imageAssist';
import shapeTelemetryHistoryReducer from './shapeTelemetryHistory';
import { RESET_STATE_TO_INITIAL } from '../actions/plaConfigurations';

const persistedShapeConfig = {
  key: 'persistedShapeInfo',
  storage,
};

// First versioned persisted slice in this app. Version 1 is just the baseline — there's
// nothing to migrate *from*, since nothing here was ever versioned before. Future schema
// changes to shapeTelemetryHistory hook in via a numbered entry in this map.
const shapeTelemetryHistoryConfig = {
  key: 'shapeTelemetryHistory',
  storage,
  version: 1,
  migrate: createMigrate({}, { debug: false }),
};

const customSurfaceReducer = combineReducers({
  config,
  configurator,
  products: productReducer,
  countertops: countertopsReducer,
  draftingTool: draftingToolReducer,
  persistedShapeInfo: persistReducer(persistedShapeConfig, persistedShapeInfo),
  zipcode: zipcodeReducer,
  store: storeReducer,
  design: designReducer,
  bazaarVoiceRatings: bazaarVoiceRatingsReducer,
  plaConfiguration: plaConfigurationReducer,
  sinkQuantityWarning: sinkQuantityWarningReducer,
  imageAssist: imageAssistReducer,
  shapeTelemetryHistory: persistReducer(shapeTelemetryHistoryConfig, shapeTelemetryHistoryReducer),
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STATE_TO_INITIAL) {
    return customSurfaceReducer(undefined, action);
  }
  return customSurfaceReducer(state, action);
};
export default rootReducer;
